import React from "react"

export default  function EditIcon(){


    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" fill="currentColor">
        <path d="M1.7915 12.2812C1.9165 11.8438 2.1665 11.4375 2.479 11.125L11.979 1.625C12.7603 0.84375 14.0415 0.84375 14.8228 1.625L16.0415 2.84375C16.1353 2.9375 16.229 3.0625 16.2915 3.15625C16.8228 3.9375 16.729 5 16.0415 5.6875L6.5415 15.1875C6.51025 15.2188 6.44775 15.25 6.4165 15.3125C6.104 15.5625 5.76025 15.75 5.38525 15.875L1.604 16.9688C1.354 17.0625 1.07275 17 0.885254 16.7812C0.666504 16.5938 0.604004 16.3125 0.666504 16.0625L1.7915 12.2812ZM2.51025 15.1562L4.94775 14.4375C5.01025 14.4062 5.104 14.375 5.1665 14.3438L4.0415 14.125C3.7915 14.0625 3.57275 13.875 3.5415 13.625L3.32275 12.5C3.2915 12.5625 3.26025 12.6562 3.229 12.7188L2.51025 15.1562ZM6.2915 13.3125L12.6353 6.96875L10.6665 5.03125L4.354 11.375L4.6665 12.9688L6.2915 13.3125Z" />
        </svg>
    )
}